import { render } from "./main.component.vue?vue&type=template&id=cb84eb52&scoped=true"
import script from "./main.component.vue?vue&type=script&lang=js"
export * from "./main.component.vue?vue&type=script&lang=js"

import "./main.component.vue?vue&type=style&index=0&id=cb84eb52&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb84eb52"

export default script